module.exports = __webpack_public_path__ + "img/category_silvester.befe06e.png";